export default function MobileHeroDiagonal({ className = '' }) {
  return (
    <div
      aria-hidden="true"
      className={`pointer-events-none absolute right-0 top-0 overflow-hidden sm:hidden ${className}`}
    >
      <svg
        viewBox="0 0 260 320"
        preserveAspectRatio="none"
        className="h-full w-full"
      >
        {/* arkadaki çok hafif ikinci katman */}
        <path
          fill="#d9d9d9"
          opacity="0.45"
          d="
            M260 10
            V320
            L132 176
            Q118 162 118 142
            Q118 122 132 108
            L260 10
            Z
          "
        />

        {/* ana turuncu shape */}
        <path
          fill="#ef760f"
          d="
            M260 0
            V308
            L126 168
            Q111 154 111 136
            Q111 118 126 102
            L260 0
            Z
          "
        />
      </svg>
    </div>
  );
}